import "./style.scss";
import { observeVideoPlayback } from "../../../js/utils/video-playback";

export default !(function() {
  const block = document.querySelector(".lms");

  if (!block) {
    return;
  }

  const videos = [...block.querySelectorAll(".lms__media--video video")];

  videos.forEach((video) => {
    observeVideoPlayback(video);
  });
})();
